import React from 'react';
import { Modal, Icon } from 'antd';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from '../../emailTemplates.less';

const cx = classNames.bind(styles);

const defaultProps = {
  visible: false,
  handleModalClose: () => {}
};

const propTypes = {
  editTemplate: PropTypes.object.isRequired,
  visible: PropTypes.bool,
  handleModalClose: PropTypes.func
};

const EmailTemplateModal = ({
  editTemplate,
  visible,
  handleModalClose,
}) => (
  <Modal
    title={editTemplate.name}
    visible={visible}
    onOk={handleModalClose}
    onCancel={handleModalClose}
    className={cx('email-theme-modal')}
  >
    <div className="mb-md">
      {editTemplate && _.isArray(editTemplate.attachments) &&
        editTemplate.attachments.map((attachment) => (
          <span className="mr-sm" key={attachment.id}>
            <Icon type="paper-clip" />
            <a href={attachment.url} target="_blank">{attachment.file_name}</a>
          </span>
        ))
      }
    </div>
    <div dangerouslySetInnerHTML={{ __html: editTemplate.content }} />
  </Modal>
);

EmailTemplateModal.propTypes = propTypes;
EmailTemplateModal.defaultProps = defaultProps;

export default EmailTemplateModal;



// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/component/templateDetailComponent/EmailTemplateModal.jsx